export const PaginationItemsPerPage = {
    FLIGHTS_PER_PAGE: 6,
}